import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import PageSEO from "@/components/feature/PageSEO";
import { articles } from "@/mocks/articles";
import { siteInfo } from "@/mocks/siteInfo";

export default function ArticleList() {
  const { t } = useTranslation();
  const breadcrumbItems = [{ label: t("nav.article") }];

  const schemas = [
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: siteInfo.name + " - " + t("nav.article"),
      description: "最新韩漫资讯、作品推荐、行业洞察、阅读指南等精彩内容，为韩漫爱好者提供专业的内容资讯。",
      url: siteInfo.url + "/article",
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: t("breadcrumb.home"), item: siteInfo.url },
        { "@type": "ListItem", position: 2, name: t("nav.article") },
      ],
    },
  ];

  return (
    <>
      <PageSEO
        title={siteInfo.name + " - " + t("nav.article")}
        description="最新韩漫资讯、作品推荐、行业洞察、阅读指南等精彩内容，为韩漫爱好者提供专业的内容资讯。"
        keywords="韩漫资讯,韩国漫画推荐,韩漫排行榜,漫画新闻,韩漫新作,免费韩漫资源"
        canonicalUrl={siteInfo.url + "/article"}
      />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemas) }} />
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          <Breadcrumb items={breadcrumbItems} />

          <section className="px-4 md:px-6 py-8 md:py-12">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-10">
                <h1 className="text-3xl md:text-4xl font-bold text-foreground-950">
                  {t("nav.article")}
                </h1>
                <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
                  最新韩漫资讯、作品推荐、行业洞察、阅读指南等精彩内容，为韩漫爱好者提供专业资讯。
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {articles.map((article) => (
                  <article
                    key={article.id}
                    className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-primary-300 hover:shadow-lg transition-all duration-300"
                  >
                    <Link to={"/article/" + article.id} className="block">
                      <div className="relative overflow-hidden aspect-[16/10]">
                        <img
                          src={article.imageUrl}
                          alt={article.title}
                          title={article.title + " - 在线漫画韩漫"}
                          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                        />
                        <div className="absolute top-3 left-3">
                          <span className="px-2.5 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs font-medium text-foreground-800">
                            {article.category}
                          </span>
                        </div>
                      </div>
                    </Link>
                    <div className="p-5">
                      <Link to={"/article/" + article.id} className="block">
                        <h3 className="text-base font-semibold text-foreground-950 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                          {article.title}
                        </h3>
                      </Link>
                      <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                        {article.excerpt}
                      </p>
                      <div className="mt-4 flex items-center gap-3 text-xs text-foreground-400">
                        <span className="flex items-center gap-1">
                          <i className="ri-user-line w-3.5 h-3.5 flex items-center justify-center"></i>
                          {article.author}
                        </span>
                        <span className="flex items-center gap-1">
                          <i className="ri-calendar-line w-3.5 h-3.5 flex items-center justify-center"></i>
                          {article.date}
                        </span>
                        <span className="flex items-center gap-1">
                          <i className="ri-time-line w-3.5 h-3.5 flex items-center justify-center"></i>
                          {article.readTime}
                        </span>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}
